// Minimal button styled against the curator's CSS variables. Three variants
// (primary, secondary, danger) cover everything we need at this scale.
import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger";
  size?: "sm" | "md";
  children: ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  style,
  ...rest
}: ButtonProps) {
  const base: React.CSSProperties = {
    fontWeight: 600,
    borderRadius: "var(--radius-sm)",
    border: "1px solid transparent",
    transition: "background-color 0.1s, border-color 0.1s",
    ...sizeStyles(size),
    ...variantStyles(variant),
    ...style,
  };

  return <button {...rest} style={base} />;
}

function sizeStyles(size: "sm" | "md"): React.CSSProperties {
  if (size === "sm") return { padding: "4px 10px", fontSize: 13 };
  return { padding: "8px 16px", fontSize: 14 };
}

function variantStyles(
  variant: "primary" | "secondary" | "danger",
): React.CSSProperties {
  switch (variant) {
    case "primary":
      return {
        backgroundColor: "var(--accent)",
        color: "#0e0e0f",
        borderColor: "var(--accent)",
      };
    case "secondary":
      return {
        backgroundColor: "transparent",
        color: "var(--text-primary)",
        borderColor: "var(--border)",
      };
    case "danger":
      return {
        backgroundColor: "var(--danger)",
        color: "#fff",
        borderColor: "var(--danger)",
      };
  }
}
